import { createModel, RematchDispatch } from '@rematch/core';
import produce from 'immer';

import { message } from 'antd';
import { AxiosError } from 'axios';
import { createTourFunctionButton } from '../../services/tour.service';
import { showMessage } from '../../utils/messageError';
import { RootModel } from '../models';

export const storeName = 'functionButtons';

const initialState = {
  data: [],
  loading: false,
};

export const functionButtons: any = createModel<RootModel>()({
  name: storeName,
  state: initialState,
  reducers: {
    setFunctionButtonData: produce((state, payload) => {
      state.data = payload;
    }),
    setLoading: produce((state, payload) => {
      state.loading = payload;
    }),
  },
  effects: (dispatch: RematchDispatch<typeof functionButtons>) => ({
    async saveFuncButton(payload, state) {
      const { data } = payload;
      const { id: tourId, code: tourCode } = state.tourDetail.data;

      try {
        this.setLoading(true);
        await createTourFunctionButton(tourId, data);
        dispatch.categories.setVisible(false);
        message.success('Success to update function button');
        dispatch.tourDetail.getTour(tourCode);
      } catch (err: unknown) {
        const axiosError = err as AxiosError;
        console.error(axiosError.message);
        showMessage(axiosError, `Fail to update function button : ${axiosError.message}`);
      } finally {
        this.setLoading(false);
      }
    },
  }),
});

export default functionButtons;
